import { parseDecimalInput } from "../../../../../../common/input/parseDecimalInput";

export type ParsedInterestRate = { kind: "empty" } | { kind: "rate"; fraction: number } | { kind: "notANumber" };

export const parseInterestRateInput = (text: string): ParsedInterestRate => {
  const parsed = parseDecimalInput(text.trim().replace(/\s*%$/, ""));
  return parsed.kind === "number" ? { kind: "rate", fraction: parsed.value / 100 } : parsed;
};
